import { useFormik } from 'formik'
import { TDocFile } from 'shared/constants/docs';
import { styled } from '@mui/material';
import { AttachmentImage } from 'shared/_model/cloud/components/CloudImage'
import DropZone from 'shared/_ui/drop-zone';
import { useCallback, useMemo } from 'react'
import useError from 'shared/helpers/use-error'

const MAX_FILE_SIZE = 10485760;

const FileImageContainer = styled('div', { name: 'FileImageContainer' })(({ theme }) => ({
	borderRadius: theme.spacing(2),
	position: 'relative',
	aspectRatio: '16 / 9',
	overflow: 'hidden',
	display: 'flex',
	flexBasis: theme.spacing(40),
	flexShrink: 0,
	height: 'max-content',
}));

export default function FileImage({ formik, isEdit }: {
	// TODO: fix type. This brings an error on webapp build
	// formik: ReturnType<typeof useFormik<TDocFile>>;
	formik: ReturnType<typeof useFormik>;
	isEdit: boolean;
}) {
	const { showError } = useError('Thumbnail upload');
	const attachments = useMemo(() => formik.values._attachments, [formik.values._attachments]);

	const handleDrop = useCallback((files: FileList) => {
		const file = [...files][0];

		const fileName = file.name.toLowerCase();
		const isValidType =
			fileName.endsWith('.png') ||
			fileName.endsWith('.jpg') ||
			fileName.endsWith('.jpeg') ||
			fileName.endsWith('.gif');

		if (!isValidType) {
			showError('Invalid file type. Only .png, .jpg, .jpeg, .gif are allowed.');
			return;
		}

		if (!file.size || file.size > MAX_FILE_SIZE) {
			showError('File size is empty or exceeds the maximum limit of 10485760 bytes.');
			return;
		}

		formik.setFieldValue('_attachments.thumbnail', {
			data: file,
			content_type: file.type,
		});
	}, [formik, showError]);

	return (
		<FileImageContainer>
			<AttachmentImage attachments={attachments} name='thumbnail' docId={formik.values._id} />
			{isEdit && (
				<DropZone
					sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
					size='small'
					onDrop={handleDrop}
				/>
			)}
		</FileImageContainer>
	);
}
